module.exports = require("core-js/modules/esnext.set.some.js");